import {asyncType} from 'redux/helpers';

export const folderReducerKey = 'FOLDERS';

export default {
   ADD_SUB_FOLDER: asyncType(`${folderReducerKey}/ADD_SUB_FOLDER`),
   RENAME_SUB_FOLDER: asyncType(`${folderReducerKey}/RENAME_SUB_FOLDER`),
   DELETE_SUB_FOLDER: asyncType(`${folderReducerKey}/DELETE_SUB_FOLDER`),
   MOVE_SUB_FOLDER: asyncType(`${folderReducerKey}/MOVE_SUB_FOLDER`),
};
